import React from "react";
import PropTypes from "prop-types";
import styles from "./Menu.module.scss";

const MenuOption = ({
  icon,
  label,
  onClick,
  disabled
}: {
  icon?: any;
  label: string;
  onClick: any;
  disabled: boolean;
}) => {
  const clickHandler = () => {
    if (disabled || !onClick) {
      return;
    }

    onClick();
  };

  return (
    <div onClick={clickHandler} className={disabled ? styles.disabledOption : styles.option}>
      <span className={styles.icon}>{icon}</span>
      <span className={styles.label}>{label}</span>
    </div>
  );
};

MenuOption.propTypes = {
  icon: PropTypes.node,
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  disabled: PropTypes.bool
};

MenuOption.defaultProps = {
  icon: null,
  onClick: null,
  disabled: false
};

export default MenuOption;
